<script lang="ts">
  import type { Speaker } from './types';
  import { Splide, SplideSlide } from '@splidejs/svelte-splide';
  import SpeakerTile from './SpeakerTile.svelte';

  type Props = {
    speakers: Speaker[];
  };

  const { speakers }: Props = $props();

  const options = {
    gap: '1rem',
    perPage: 3,
    pagination: false,
    breakpoints: {
      767: {
        perPage: 2,
      },
      500: {
        perPage: 1,
      },
    }
  };
</script>

<div class="speakers-gallery">
  <Splide class="no-init" {options}>
    {#each speakers as speaker}
      <SplideSlide>
        <SpeakerTile {speaker} />
      </SplideSlide>
    {/each}
  </Splide>
</div>

<style>
  .speakers-gallery :global(.splide__arrow[disabled]) {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }

  .speakers-gallery :global(.splide__list) {
    list-style: none;
  }

  .speakers-gallery :global(.splide__slide) {
    margin: 0;
  }

  .speakers-gallery :global(.splide .splide__arrows) {
    left: -1rem;
    right: -1rem;
  }

  .speakers-gallery :global(.splide .splide__arrows .splide__arrow) {
    background-color: theme('colors.pink');
  }
</style>